<template>
  <div class="modal-window" :class="{'open': add_attachment_popup_open}" @click="add_attachment_popup_open = false">
    <div class="modal-window-inner" @click.stop>
      <div class="modal-close" @click.stop="add_attachment_popup_open = false">
        <i class="fal fa-times"></i>
      </div>
      <div class="modal-header">
        <h1 class="modal-title">Add Attachment</h1>
      </div>
      <div class="modal-content">
        <div class="form-group mb-0-sm full-height flex flex-col">
          <label>Upload Attachment</label>
          <form :action="`${$aws_upload_url}`" method="post"
                enctype="multipart/form-data" id="amazon_form">
            <input type="hidden" name="policy" :value="aws_policy">
            <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
            <input type="hidden" name="x-amz-credential" :value="aws_credential">
            <input type="hidden" name="x-amz-date" :value="aws_date">
            <input type="hidden" name="x-amz-signature" :value="aws_signature">
            <input type="hidden" name="acl" value="private">
            <!--              <input type="hidden" name="success_action_redirect" value="/news/manage">-->
            <input type="hidden" name="Content-Type" v-model="filetype">
            <input type="hidden" name="key" v-model="new_attachment.filename">
          </form>
          <vue-dropzone
              ref="fileUploadDropzone"
              id="dropzone"
              :options="dropzoneOptions"
              v-on:vdropzone-file-added="fileAddedToDropZone"
              v-on:vdropzone-removed-file="fileRemovedFromDropZone"
              :useCustomSlot="true"
          >
            <div>
              <div class="mb-3">
                DRAG AND DROP FILE
              </div>
              <div class="mb-3">
                OR
              </div>
              <div>
                <a class="btn-secondary-outline">
                  Choose a file
                </a>
              </div>
            </div>
          </vue-dropzone>
        </div>
      </div>
      <div class="modal-footer align-right">
        <a class="btn-primary" @click="saveAttachment()">
          Save
        </a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
  ],
  data() {
    return {
      new_attachment: {
        file_name: '',
      },
      filename: '',
      filetype: '',
      uploaded_file: null,
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    fileAddedToDropZone(uploadedFile) {
      const extension = uploadedFile.name.replace(/^.*\./, '');

      const allowed_extensions = [
        'jpg', 'jpeg', 'png', 'svg', 'gif', 'bmp',
      ];

      if (!allowed_extensions.includes(extension.toLowerCase())) {
        this.$refs.fileUploadDropzone.dropzone.removeAllFiles();
        Swal.fire({
          title: 'Invalid File Type',
          icon: 'error',
          text: 'File type not allowed, please ensure the file is one of the following formats: \'jpg\', \'jpeg\', \'png\',  \'svg\', \'gif\', \'bmp\','
        });
        return;
      }

      if (this.$refs.fileUploadDropzone.dropzone.files.length > 1) {
        this.$refs.fileUploadDropzone.dropzone.removeFile(this.$refs.fileUploadDropzone.dropzone.files[0]);
      }

      const filename = 'faq_attachments/' + Date.now();
      this.new_attachment.filename = filename + '.' + extension;

      this.filetype = uploadedFile.type;
      this.uploaded_file = uploadedFile;
    },
    fileRemovedFromDropZone(file) {
      this.uploaded_file = null;
      this.new_attachment.filename = null;
      this.filetype = null;
    },
    saveAttachment() {
      console.log('save attachment');
    },
  },
  watch: {
  },
};
</script>
